<template>
  <div class="mMobileBeer-container" v-show="isLoaded">
    <h3 class="mSection-title" v-observe-visibility="startAnimate" :class="{animate: animate}">Cerveza Indio</h3>
    <div class="red-box" :class="{animate: animate}">
      <p>
        Indio es una cerveza oscura mexicana estilo Lager Vienna creada de la fusión de
        dos ingredientes: malta dorada y notas de caramelo tostado, dándole
        leves tonos de dulzor y reduciendo los niveles de amargor.
      </p>
      <br />
      <p>
        El sabor único de cerveza Indio ofrece una combinación muy especial para
        aquellos que buscan sabores auténticos y experiencias únicas.
      </p>
    </div>
    <div class="mFlex-container">
      <div class="mCol-1">
        <div class="feature-1" :class="{animate: animateBeer}">
          <h5 class="property">Estilo</h5>
          <h5 class="prop-value">Lager Vienna</h5>
        </div>
        <div class="feature-2" :class="{animate: animateBeer}">
          <h5 class="property">Alcohol</h5>
          <h5 class="prop-value">4.1% <span>ALC. VOL.</span></h5>
        </div>
        
      </div>
      <div class="mCol-2" :class="{animate: animateBeer}" v-observe-visibility="startAnimateBeer">
        <img :src="botella" alt="Botella Indio" />
      </div>
      <div class="mCol-3">
        <div class="feature-4" :class="{animate: animateBeer}">
          <h5 class="property">Color</h5>
          <h5 class="prop-value">Oscuro</h5>
        </div>
        <!-- <div class="feature-5" :class="{animate: animateBeer}">
          <h5 class="property">Amargor</h5>
          <h5 class="prop-value">12 Grados</h5>
        </div> -->
        <div class="feature-3" :class="{animate: animateBeer}">
          <h5 class="property">Calorías</h5>
          <h5 class="prop-value">35 Cal/<span>100 ml</span></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import botella from "@/assets/indio_botella.png";
import { mapGetters } from "vuex";

export default {
  name: "MobileBeer",
  data() {
    return {
      botella,
      animate: false,
      animateBeer: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    },
    startAnimateBeer(isVisible){
      if(isVisible){
        this.animateBeer=true
      }
      
    }
  },
  components: {},
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/MobileBeer.scss";
</style>
